const config = {
  'API_BASE_URL': 'https://api.kegmeisters.com',
  'S3_BUCKET_URL': 'https://kegmeistersdevelopment.s3.amazonaws.com',
  'STRIPE_API_KEY': 'pk_live_ZF56SHcyKTyMyHO2SnhSMX6y'
}

// 'API_BASE_URL': 'https://api.kegmeisters.com',
// 'STRIPE_API_KEY': 'pk_test_sZZbr72yF22bKOTuLguRCPhJ'
// 'API_BASE_URL': 'https://kegmeisters-staging.herokuapp.com',
// 'API_BASE_URL': 'https://api.kegmeisters.com',

export const kegSizes = ['half_barrel', 'mini_keg', 'cornelius_keg', 'sixth_barrel', 'quarter_barrel', 'slim_quarter', 'rubber_barrel', 'beveled_barrel', 'fifty_liter', 'thirty_liter']

export default config



// WEBPACK FOOTER //
// ./src/config.js